import { create } from 'zustand';

import { Product } from '@/entities/product';

import type { FavoriteGuestEntry } from './favoriteGuestStore';

interface AuthFavoriteState {
  entries: FavoriteGuestEntry[];
  setFromProducts: (products: Product[]) => void;
  upsertProduct: (product: Product) => void;
  removeById: (productId: number) => void;
  clear: () => void;
}

function toEntry(product: Product): FavoriteGuestEntry {
  return {
    id: product.id,
    slug: product.slug,
    name: product.name,
    image: product.image,
    subcategory: product.subcategory,
  };
}

export const useAuthFavoriteStore = create<AuthFavoriteState>((set, get) => ({
  entries: [],
  setFromProducts: (products) =>
    set({ entries: products.map((p) => toEntry(p)) }),
  upsertProduct: (product) => {
    const entry = toEntry(product);
    const rest = get().entries.filter((e) => e.id !== entry.id);

    set({ entries: [...rest, entry] });
  },
  removeById: (productId) =>
    set({ entries: get().entries.filter((e) => e.id !== productId) }),
  clear: () => set({ entries: [] }),
}));
